// initial state
import { recordingsCollection } from '@/firebase';
import { storage } from '@/firebase';
import router from '@/router/index'
import { foldersCollection } from '../../firebase';

const state = {
    audio: {},
    audioLoading: false,

    audioList: [],
    isListLoading: false,

    createAudio: {},
    createLoading: false,

    updateAudio: {},
    updateLoading: false,

    deleteLoading: false,

    uploadProgress: null,
};

// mutations
const mutations = {
    SET_AUDIO_LIST: (state, audioList) => {
        state.audioList = audioList
    },
    SET_IS_LOADING: (state, loading) => {
        state.audioLoading = loading;
    },
    SET_IS_AUDIO_LOADING: (state, loading) => {
        state.isListLoading = loading;
    },
    SET_CREATION_LOADING: (state, loading) => {
        state.createLoading = loading;
    },
    SET_UPDATE_LOADING: (state, loading) => {
        state.updateLoading = loading;
    },
    SET_DELETE_AUDIO: (state, audio) => {
        state.audioList = state.audioList.filter(
            item => item.id !== audio.id
        );
    },
    SET_DELETE_FOLDERS: (state, folderName) => {
        state.audioList = state.audioList.filter(
            item => item.folderName !== folderName
        );
    },
    SET_DELETION_LOADING: (state, loading) => {
        state.deleteLoading = loading;
    },
    SET_UPLOAD_PROGRESS: (state, progress) => {
        state.uploadProgress = progress;
    },
};

// actions
const actions = {
    onFetchAudiosList: async ({ commit, dispatch }) => {
        try {
            commit('SET_IS_AUDIO_LOADING', true);
            var querySnapshot = await recordingsCollection.get()
            if (querySnapshot.empty) {
                commit('SET_AUDIO_LIST', []);
            } else {
                var updatedList = [];
                querySnapshot.docs.map(doc => {
                    updatedList.push({
                        'id': doc.id,
                        'name': doc.data().name,
                        'folderName': doc.data().folderName,
                        'streamUrl': doc.data().streamUrl,
                        'plays': doc.data().plays,
                    })
                });
                const sortedList = updatedList.sort((a, b) => {
                    if (a.folderName < b.folderName)
                        return -1;
                    if (a.folderName > b.folderName)
                        return 1;
                    return 0;
                });
                commit('SET_AUDIO_LIST', sortedList);
            }
            commit('SET_IS_AUDIO_LOADING', false);
        } catch (error) {
            commit('SET_AUDIO_LIST', []);
            commit('SET_IS_AUDIO_LOADING', false);
            const notify = {
                message:
                    error || 'error',
            };
            dispatch('notify/show', notify, { root: true });
        }
    },
    onCreateAudio: async ({ commit, dispatch }, { model, files }) => {
        try {
            commit('SET_CREATION_LOADING', true);
            var percentage = 0;
            const totalSize = files.reduce((sum, file) => {
                return (sum += file.size);
            }, 0);
            for (const file of files) {
                const fileName = file.name.substring(0, file.name.lastIndexOf("."));
                const result = await recordingsCollection
                    .where('name', '==', fileName)
                    .where('folderName', '==', model.folderName)
                    .get();
                var isNewFile = result.empty;
                if (isNewFile) {
                    var storageRef = await storage.ref('recordings/' + model.folderName + '/' + fileName);
                    percentage += ((file.size * .25) / totalSize) * 100;
                    commit('SET_UPLOAD_PROGRESS', percentage);
                    var snapshot = await storageRef.put(file);
                    var downloadURL = await snapshot.ref.getDownloadURL();
                    await recordingsCollection
                        .doc()
                        .set({
                            'name': fileName,
                            'folderName': model.folderName,
                            'streamUrl': downloadURL,
                            'plays': 0,
                        });
                    percentage += ((file.size * .75) / totalSize) * 100;
                    commit('SET_UPLOAD_PROGRESS', percentage);
                } else {
                    percentage += (file.size / totalSize) * 100;
                    commit('SET_UPLOAD_PROGRESS', percentage);
                }
            }
            commit('SET_UPLOAD_PROGRESS', null);
            commit('SET_CREATION_LOADING', false);
            router.push({ name: 'recordings' })
        } catch (error) {
            commit('SET_UPLOAD_PROGRESS', null);
            commit('SET_CREATION_LOADING', false);
            const notify = {
                message:
                    error || 'error',
            };
            dispatch('notify/show', notify, { root: true });
        }
    },
    onDeleteAudio: async ({ commit, dispatch }, audio) => {
        try {
            commit('SET_DELETION_LOADING', true);
            await recordingsCollection.doc(audio.id).delete();

            //create ref
            var storageRef = storage.ref('recordings/' + audio.folderName + '/' + audio.name);
            // Delete the file
            storageRef.delete().then(() => {
                dispatch(
                    'notify/show',
                    {
                        type: 'success',
                        message: 'تم حذف العنصر من قاعدة البيانات'
                    },
                    { root: true }
                );
                commit('SET_DELETION_LOADING', false);
                commit('SET_DELETE_AUDIO', audio);
            }).catch((error) => {
                throw error
            });

        } catch (error) {
            commit('SET_DELETION_LOADING', false);
            const notify = {
                message:
                    error || 'error',
            };
            dispatch('notify/show', notify, { root: true });
        }
    },
    onDeleteFolder: async ({ commit, dispatch }, folderName) => {
        try {
            commit('SET_DELETION_LOADING', true);
            const query = await foldersCollection
                .where('name', '==', folderName)
                .where('parentId', '==', 'recordings')
                .get();
            await foldersCollection.doc(query.docs[0].id).delete();

            var audioList = state.audioList.filter(audio => audio.folderName == folderName);
            for (const audio of audioList) {
                await recordingsCollection.doc(audio.id).delete();
                var storageRef = storage.ref('recordings/' + audio.folderName + '/' + audio.name);
                await storageRef.delete();
            }
            dispatch(
                'notify/show',
                {
                    type: 'success',
                    message: 'تم حذف المجلد من قاعدة البيانات'
                },
                { root: true }
            );
            commit('SET_DELETION_LOADING', false);
            commit('SET_DELETE_FOLDERS', folderName);

        } catch (error) {
            commit('SET_DELETION_LOADING', false);
            const notify = {
                message:
                    error || 'error',
            };
            dispatch('notify/show', notify, { root: true });
        }
    }
};

// getters
const getters = {
    isRecordingsLoading: state =>
        state.isListLoading || state.deleteLoading || state.createLoading
        || state.updateLoading || state.audioLoading
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
};
